"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandToMerchantPermissionsToJSON = exports.BrandToMerchantPermissionsFromJSONTyped = exports.BrandToMerchantPermissionsFromJSON = void 0;
var _1 = require("./");
function BrandToMerchantPermissionsFromJSON(json) {
    return BrandToMerchantPermissionsFromJSONTyped(json, false);
}
exports.BrandToMerchantPermissionsFromJSON = BrandToMerchantPermissionsFromJSON;
function BrandToMerchantPermissionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'brand': (0, _1.BrandFromJSON)(json['brand']),
        'merchant': (0, _1.MerchantFromJSON)(json['merchant']),
        'createMaps': json['createMaps'],
    };
}
exports.BrandToMerchantPermissionsFromJSONTyped = BrandToMerchantPermissionsFromJSONTyped;
function BrandToMerchantPermissionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'brand': (0, _1.BrandToJSON)(value.brand),
        'merchant': (0, _1.MerchantToJSON)(value.merchant),
        'createMaps': value.createMaps,
    };
}
exports.BrandToMerchantPermissionsToJSON = BrandToMerchantPermissionsToJSON;
